import React, { Component } from "react";

export default class Timeline extends Component {
  render() {
    return (
      <div>
        <section id="colorlib-timeline" className="colorlib-experience" data-section="timeline">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div
                className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
                data-animate-effect="fadeInLeft"
              >
                <span className="heading-meta">highlights</span>
                <h2 className="colorlib-heading animate-box">Timeline</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="timeline-centered">
                <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-2">
                        <i className="icon-pin-outline" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <span>Software Engineer - ITV Plc</span> <span>Apr 2025 - Present</span>
                        </h2>
                        <p>
                          Building backend solutions in Python and AWS for media operations, with strong focus on maintainability, testing, and delivery through Agile and CI/CD workflows.
                        </p>
                      </div>
                    </div>
                  </article>
                <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-7">
                        <i className="icon-pin-outline" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <span>Mid-Level Accelerator - Code First Girls</span> <span>Apr 2026 - Present</span>
                        </h2>
                        <p>
                          Advancing cloud-native Python architecture,
                          CI/CD practices, and scalable system design through
                          an intensive transition program for mid-senior roles.
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pin-outline" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <span>Career Gap / Upskilling</span> <span>May 2024 - Mar 2025</span>
                        </h2>
                        <p>
                          Completed intensive programs in SQL, JavaScript,
                          and Python & Apps to strengthen data and application
                          engineering capabilities.
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInTop"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-4">
                        <i className="icon-pin-outline" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <span>Graduate Software Engineer - Frontend, M&S</span> <span>2023 - 2024</span>
                        </h2>
                        <p>
                          Delivered responsive features with HTML, CSS,
                          TypeScript, and Next.js; supported GraphQL
                          federation adoption and improved reliability through
                          automated testing and CI/CD improvements.
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pin-outline" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <span>Graduate Software Engineer - Backend, M&S</span> <span>2022 - 2023</span>
                        </h2>
                        <p>
                          Built Java and Spring Boot microservices for customer
                          engagement workflows, improved observability and
                          deployment readiness, and contributed to reliable REST
                          API integration in an Agile environment.
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-6">
                        <i className="icon-pin-outline" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <span>Internship - Newson.io</span> <span>2021</span>
                        </h2>
                        <p>
                          Collaborated with cross-functional teams on product
                          features, experimentation, and market insights to
                          improve engagement and conversion.
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-7">
                        <i className="icon-pin-outline" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <span>Teacher - Multiple Schools and College</span> <span>2013 - 2022</span>
                        </h2>
                        <p>
                          Taught Computer Science, Mathematics, and Robotics,
                          building strong communication and mentoring skills
                          that now support cross-functional engineering work.
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pin-outline" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <span>Master of Computer Application - Anna University</span> <span>2010 - 2013</span>
                        </h2>
                        <p>
                          Completed postgraduate studies in computer
                          applications and software fundamentals.
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInTop"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-4">
                        <i className="icon-pin-outline" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <span>Bachelor of Computer Applications - Bharathidasan University</span>{" "}
                          <span>2007 - 2010</span>
                        </h2>
                        <p>
                          Built core programming skills and software
                          development foundations that shaped my engineering
                          career.
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry begin animate-box"
                    data-animate-effect="fadeInBottom"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-none" />
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
